<template>
    <div id="job_jobs" class="content">
        <AllJobs />
    </div>
</template>

<script>
import AllJobs from "~/components/AllJobs";

export default {
    components: {
        AllJobs,
    },
    layout: "with_search_all",
    async asyncData({ store }) {
        await store.dispatch("enum/indexCache");
    },
    head() {
        return {
            title: this.$t("pages.jobs.title"),
        };
    },
    async mounted() {
        await this.$store.dispatch("jobs/initializeSearch", this.$route.query);
    },
};
</script>
